import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { bonuses, BONUS_TOTAL_VALUE } from '../data/bonuses';
import { CountdownTimer } from './CountdownTimer';
export function BonusSection() {
  return <section className="py-24 px-4 bg-dark-card border-y border-dark-border" data-id="element-15" data-mp="22f3fjjh73npo">
      <div className="max-w-5xl mx-auto" data-id="element-16" data-mp="1yf3324dnpml9">
        <div className="text-center mb-16" data-id="element-17" data-mp="1ybxeqrcuqoql">
          <p className="text-gold font-bold tracking-widest uppercase mb-2 text-sm" data-id="element-18" data-mp="1annwfzeukj47">
            Inclusi senza costo aggiuntivo
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold" data-id="element-19" data-mp="15r740t0m7ilb">
            🎁 I 5 Bonus Strategici
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12 items-stretch" data-id="element-20" data-mp="1eqare96tek5m">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: index % 2 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-black border border-gold/20 rounded-2xl p-8 relative flex flex-col h-full hover:border-gold/50 transition-colors duration-200 ease-out ${index === bonuses.length - 1 ? 'md:col-span-2' : ''}`} data-id="element-21" data-mp="qzojchwt8zvm" data-mpi={index}>
              <p className="absolute top-0 right-0 bg-gold/10 text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-22" data-mp="1qus4dxakl1xb">
                BONUS {bonus.id}
              </p>

              <span className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold mb-6" data-id="element-23" data-mp="20thozxtup0h9">
                <GiftIcon size={24} aria-hidden="true" data-id="element-24" data-mp="3c6k4epk7rjzu" />
              </span>

              <h3 className="text-xl font-serif font-bold mb-3 pr-24" data-id="element-25" data-mp="3c8o5kzqqa4wf">
                {bonus.title}
              </h3>

              <p className="inline-block self-start bg-white/5 px-3 py-1 rounded mb-4 text-sm" data-id="element-26" data-mp="1h3f19lwqd342">
                <span className="text-gray-400" data-id="element-27" data-mp="1c4at8yljlbfb">
                  Valore separato:{' '}
                  <span className="line-through" data-id="element-28" data-mp="1c6ol6ykxe7in">{bonus.value}</span>
                </span>
                <span className="text-gold font-bold ml-2" data-id="element-29" data-mp="1q1zck1zyoai9">→ GRATIS</span>
              </p>

              <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-30" data-mp="1m39p1gl7lckw">
                {bonus.desc}
              </p>

              <p className="text-gold-light text-sm italic font-medium mt-auto" data-id="element-31" data-mp="yajl9unglzlp">
                {bonus.benefit}
              </p>
            </motion.article>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-gold/10 border border-gold/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-32" data-mp="177c1gmpcpgka">
          <p className="text-gray-300 mb-2" data-id="element-33" data-mp="j4pc4prvcki">Valore totale dei 5 Bonus</p>
          <p className="text-2xl text-gray-500 line-through mb-4" data-id="element-34" data-mp="5a4n1c6ptyo2">
            {BONUS_TOTAL_VALUE}
          </p>
          <p className="text-lg text-white mb-2" data-id="element-35" data-mp="3mqurq5v6i1pi">Il tuo prezzo oggi</p>
          <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-36" data-mp="3morup1vlz8ba">
            🎁 GRATIS
          </p>
          <p className="text-sm text-gold-light" data-id="element-37" data-mp="3rncuj06y7pz7">
            Inclusi soltanto con questa offerta.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-38" data-mp="o98s69v4z8ag" />
      </div>
    </section>;
}